export default {
  customCodeInEditMode: [],
  widgetsInEditMode: [],
  computedPropsInEditMode: []
}
